export const emptyPaginatedData = { records: [], count: 0 };
